import React from 'react'
import { Card } from 'react-bootstrap'
import { ChevronRight } from 'react-bootstrap-icons';
import styles from './OptionCard.module.scss'
import { useNavigate } from 'react-router-dom';
export default function OptionCard(props) {
    const { image, title, nav } = props;
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(nav)
    }
    return (
        <Card className={`${styles.card}`} onClick={handleClick}>
            <div className={`${styles.top}`}>
                <Card.Img variant="top" src={image} className={`${styles.imagess}`} />
                <ChevronRight className={`${styles.icon}`} />
            </div>
            <Card.Body className={`${styles.body}`}>
                <Card.Title className={`${styles.title}`}>{title}</Card.Title>
            </Card.Body>
        </Card>
    )
}
